import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';
import { PopupMessageContent } from './PopupMessageContent';

export const PopupMessage: React.FC = () => {
  const queue = useSelector((state: RootState) => state.popupMessage.queue);
  const config = queue[0];
  if (!config) {
    return null;
  }
  return (
    <PopupMessageContent config={config} hasQueuedFollowUp={queue.length > 1} />
  );
};
